import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Switch, FormControlLabel, Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { FormProvider, useForm } from 'react-hook-form';
import { ProviderSettingsWrapper } from 'pages/Providers/styles';
import { getProvidersPickupPrice } from 'redux/actions/providers';
import { useDispatch } from 'react-redux';

const providerPricingSchema = yup.object().shape({
  allowPickupPrice: yup.boolean(),
});

const ProviderPricing = ({ disabled, provider, providerLoading }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const defaultValues = useMemo(
    () => ({
      allowPickupPrice: provider?.allowPickupPrice || false,
    }),
    [provider]
  );

  const providerPricingForm = useForm({
    mode: 'all',
    defaultValues,
    resolver: yupResolver(providerPricingSchema),
  });

  const {
    reset,
    getValues,
    register,
    handleSubmit,
    formState: { isDirty },
  } = providerPricingForm;

  useEffect(() => {
    reset({
      allowPickupPrice: provider?.allowPickupPrice,
    });
  }, [provider, reset]);

  const handleProviderPricingFormSubmit = (values) => {
    setLoading(true);
    const body = {
      provider: provider?.srv || '',
      enabled: values.allowPickupPrice,
    };

    dispatch(getProvidersPickupPrice(body))
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <ProviderSettingsWrapper>
      <Box
        sx={{
          px: 2,
          pt: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <FormProvider {...providerPricingForm}>
          <form onSubmit={handleSubmit(handleProviderPricingFormSubmit)}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <FormControlLabel
                disabled={disabled}
                control={
                  <Switch
                    {...register('allowPickupPrice')}
                    checked={getValues('allowPickupPrice')}
                  />
                }
                label={t('Allow separate Pick-up and Delivery prices')}
              />
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <LoadingButton
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={!isDirty || loading || providerLoading}
                  loading={loading || providerLoading}
                >
                  {t('orders_history.apply')}
                </LoadingButton>
              </Box>
            </Box>
          </form>
        </FormProvider>
      </Box>
    </ProviderSettingsWrapper>
  );
};

export default ProviderPricing;
